import assetsServices from 'src/services/assetsServices';

export const DEFAULT_PROFILE_PHOTO = 'https://profile-assets.sendsquared.com/profile-photos/default-user-profile.png';

const state = {
  photoUrls: {},
};

const pending = new Set();

const getters = {
  getPhotoUrl: (state) => (assetId) => {
    if (!assetId) return DEFAULT_PROFILE_PHOTO;
    return state.photoUrls[assetId] || DEFAULT_PROFILE_PHOTO;
  },
};

const actions = {
  async resolvePhotoUrl({ commit, state }, assetId) {
    if (!assetId) {
      return DEFAULT_PROFILE_PHOTO;
    }
    if (state.photoUrls[assetId]) {
      return state.photoUrls[assetId];
    }
    if (pending.has(assetId)) {
      return DEFAULT_PROFILE_PHOTO;
    }
    pending.add(assetId);
    try {
      const response = await assetsServices.fetchAsset(assetId);
      const url = response.data?.url || DEFAULT_PROFILE_PHOTO;
      commit('setPhotoUrl', { assetId, url });
      return url;
    } catch (e) {
      console.error('Failed to resolve photo for asset', assetId, e);
      return DEFAULT_PROFILE_PHOTO;
    } finally {
      pending.delete(assetId);
    }
  },

  async resolvePhotoUrls({ dispatch }, assetIds) {
    const unique = [...new Set(assetIds.filter(Boolean))];
    await Promise.all(unique.map(id => dispatch('resolvePhotoUrl', id)));
  },

  setCachedPhotoUrl({ commit }, { assetId, url }) {
    if (assetId && url) {
      commit('setPhotoUrl', { assetId, url });
    }
  },
};

const mutations = {
  setPhotoUrl(state, { assetId, url }) {
    state.photoUrls[assetId] = url;
  },
  removePhotoUrl(state, assetId) {
    delete state.photoUrls[assetId];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
